import { forwardRef, useCallback, type InputHTMLAttributes } from 'react';
import { isValidTCKN } from '@custel/turkish';
import { Input } from '../Field';
import { cn } from '../../../lib/cn';

export interface TCKNInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  validate?: boolean;
}

/**
 * TCKN — 11 hane, NVI Mod-10 algoritması ile live validate.
 * 11 haneye ulaşmadan invalid flag basılmaz (kullanıcı yazarken kırmızı yanmaz).
 */
export const TCKNInput = forwardRef<HTMLInputElement, TCKNInputProps>(
  ({ value, onChange, validate = true, className, ...rest }, ref) => {
    const valid = !validate || value.length < 11 || isValidTCKN(value);

    const handle = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.replace(/\D+/g, '').slice(0, 11);
        onChange(raw);
      },
      [onChange],
    );

    return (
      <Input
        ref={ref}
        value={value}
        onChange={handle}
        placeholder="12345678901"
        inputMode="numeric"
        autoComplete="off"
        spellCheck={false}
        maxLength={11}
        aria-invalid={!valid}
        className={cn('font-mono tracking-widest', className)}
        {...rest}
      />
    );
  },
);
TCKNInput.displayName = 'TCKNInput';
